<template>

  <component :is="el" :label="label" :required="required">

    <el-cascader
        v-model="form"
        placeholder="Select Locality..."
        :options="locality.regions"
        :disabled="disabled"
        :props="{label: 'name', value: 'name', children: 'divisions'}"
        :size="size"
        :show-all-levels="showLevels"
        filterable
        :clearable="clearable"
        @change="updated">
  </el-cascader>

</component>
</template>

<script>

import {localityData} from '@/components/Data'

export default {
  name: 'select-locality',

  props: {
    label: {
      type: String,
      default: 'Locality'
    },
    value: {
//      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'default'
    },
    placeholder: {
      type: String,
      default: null
    },
    helpText: {
      type: String,
      default: null
    },
    showLevels: {
      type: Boolean,
      default: true
    },
    noForm: {
      type: Boolean,
      default: false
    },
    // XOL-67 (v2.2): additive. An x clears the locality (the change is `[]`). Default false: every other call site renders as before.
    clearable: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updated (value) {
      this.$emit('input', value)
      this.$emit('change', value)
    },

    formatValue () {
      return this.form
    }
  },

  data () {
    return {
      el: this.noForm ? 'div' : 'el-form-item',
      // The cascader's own copy, without the empty levels. The global removeNullArray splices the array it is given in place (and skips every second
      // null), which was the PARENT's `loc`: [null, 'Selangor', 'Gombak'] became [region 'Selangor', state 'Gombak'] in the form that saved it (XOL-67 V6 review).
      // The prop is never written.
      form: this.value ? this.value.filter(function (v) { return !!v }) : null,
      locality: localityData
    }
  }
}
</script>

<style scoped>
.el-cascader {display: inline-block; width: 100%;}
</style>
